import { render, staticRenderFns } from "./rock.vue?vue&type=template&id=afbd00d4"
import script from "./rock.vue?vue&type=script&lang=js"
export * from "./rock.vue?vue&type=script&lang=js"
import style0 from "./rock.vue?vue&type=style&index=0&id=afbd00d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports